import * as React from "react"
import { RentalAdvert, SprocketAsset, SaleAdvert } from "../../../types/types";
import ContentGoogleMaps from "./ContentGoogleMaps";
import { StaticMapImage } from "../../../utils/advert";


export type ContentMapType = 'static' | 'interactive'
type Props = {
  advert: RentalAdvert | SaleAdvert
  mapType: ContentMapType
  setMapType: (t: ContentMapType) => void
  icon: SprocketAsset
  googleMapsKey: string
}

export default (props: Props) : JSX.Element => {
  const staticImage = StaticMapImage(props.advert, props.googleMapsKey)
  return <>
    {
      props.mapType == 'static' && staticImage ?
        <>
          <img
            src={staticImage}
            className="location-img"
            onClick={() => props.setMapType("interactive")}
          />
          <em>
            {I18n.t('adverts.google_maps.click_on_image')}
          </em>
        </>
      : props.mapType == 'interactive' ?
        <ContentGoogleMaps
          mapElement={<div style={{ height: '100%' }} />}
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: '300px', width: '100%' }} />}
          lat={props.advert.latitude}
          lng={props.advert.longitude}
          icon={props.icon}
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${props.googleMapsKey}&libraries=places`}
        />
      : ''
    }
  </>
}
